module.exports = __webpack_public_path__ + "img/automatic.7b6d4783.svg";